import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Profil } from 'src/app/shared/models/profil';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrl: './profil.component.scss'
})
export class ProfilComponent {

  infoUser:any;
  item :Profil = new Profil();
  constructor(

    private authService:AuthService,
    private localStorage:LocalStorageService,
    private messageService:MessageService,
    private router:Router,
    private ngxUiLoader :NgxUiLoaderService

  ){}

  ngOnInit(){
    this.infoUser = this.localStorage.getInfoUserToService()?.data?.user;
    this.item.user_ref=this.infoUser.reference

  }

  updateProfil(){

    if (!this.item.canSend()) {
      this.messageService.add({ severity: 'info', summary: 'X-Project', detail: this.item.getErrorMessage() });
      return;
    }

    if (this.item) {

      this.ngxUiLoader.start();
      this.authService.updateProfil(this.item).subscribe(
        (response: any) => {
          this.ngxUiLoader.stop();

          this.messageService.add({ severity: 'success', summary: 'X-Project', detail: response.message });

          this.router.navigate(['/login']);
          localStorage.clear();

        },
        (error) => {
        this.ngxUiLoader.stop();

          this.messageService.add({ severity: 'error', summary: 'X-Project', detail: error });

        }
      ).add(() => {
      });
    }
  }
}
